import {
    Box,
    BottomSheet,
    Drawer,
    TemplateItem,
    Text,
    useMediaQuery,
    transfersTestIds,
} from "@ui-kit/components/index.es";
import { arrayOf, bool, func, shape } from "prop-types";
import React from "react";
import { connect } from "react-redux";

import * as i18n from "util/i18n";
import { actions as templateActions } from "reducers/template";

function TemplateDrawerV3(props) {
    TemplateDrawerV3.propTypes = {
        isVisible: bool.isRequired,
        templates: arrayOf(shape({})).isRequired,
        setVisible: func.isRequired,
        dispatch: func.isRequired,
        onSelect: func.isRequired,
    };

    const { isVisible, templates, setVisible, onSelect } = props;
    const isMobile = useMediaQuery("min", "md");

    const handleTemplateDelete = (item) => {
        const { dispatch } = props;
        dispatch(templateActions.deleteTemplate(item));
    };

    const renderTemplateItems = () =>
        templates.map((template) => (
            <TemplateItem
                key={template.idTransactionTemplate}
                data-testid={transfersTestIds.templates.item(template.idTransactionTemplate)}
                content={<Text variant="body2">{template.name}</Text>}
                onDelete={() => {
                    handleTemplateDelete(template);
                }}
                onClick={() => {
                    onSelect(template.transactionData);
                }}
            />
        ));

    return (
        <Box data-testid={transfersTestIds.templates.drawer} flex>
            {isMobile ? (
                <BottomSheet
                    title={i18n.get("transfers.templates.mb")}
                    iconTitle="NewspaperAlt"
                    onClose={() => setVisible(false)}
                    isVisible={isVisible}
                    renderWithPortal>
                    {renderTemplateItems()}
                </BottomSheet>
            ) : (
                <Drawer
                    controlElementId="open-menu"
                    keepFixedOnWeb={false}
                    iconTitle="NewspaperAlt"
                    mainContentId="drawer-left-main"
                    onClose={() => setVisible(false)}
                    placement="right"
                    isVisible={isVisible}
                    title={i18n.get("transfers.templates")}
                    searcher
                    styleV3>
                    {renderTemplateItems()}
                </Drawer>
            )}
        </Box>
    );
}

export default connect()(TemplateDrawerV3);
